var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-finder__results" },
    [
      _c(
        "global-loading-overlay",
        { attrs: { showLoading: _vm.freeze && _vm.freeze !== "no-overlay" } },
        [_vm._v("\n        " + _vm._s(_vm.localization.loading) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "result-count col-12" }, [
        _c("p", [
          _vm._v(_vm._s(_vm.total) + " "),
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.localization.labels.results) },
          }),
        ]),
        _c("div", { staticClass: "decoration" }),
      ]),
      _vm._v(" "),
      _vm.results.length
        ? [
            _vm._l(_vm.results, function (result) {
              return [
                _c(
                  "div",
                  {
                    class: [
                      "global-material-tile",
                      _vm.constants.gridColumns[_vm.cols],
                    ],
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "tile--link",
                        attrs: { href: result.detail_link },
                        on: {
                          click: function ($event) {
                            return _vm.openLink(result.detail_link, $event)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "tile--image img-fluid",
                          attrs: {
                            width: "200",
                            height: "200",
                            title: result.title,
                            src: result.image_src,
                            alt: result.title,
                          },
                          on: { load: _vm.onImageLoaded },
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "tile--title" }, [
                          _c("b", [_vm._v(_vm._s(result.title))]),
                          _vm._v(" " + _vm._s(result.titlesuffix)),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "tile--subtitle" }, [
                          _vm._v(_vm._s(result.subtitle)),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            }),
            _vm._v(" "),
            _vm.total - _vm.results.length > 0
              ? [
                  _c(
                    "div",
                    { staticClass: "button-wrapper v-center right col-12" },
                    [
                      _c("span", { staticClass: "button-label" }, [
                        _vm._v(_vm._s(_vm.results.length) + " "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.localization.labels.of),
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.total) + " "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.localization.labels.results),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("button", {
                        staticClass: "button button--secondary",
                        domProps: {
                          innerHTML: _vm._s(_vm.localization.labels.loadmore),
                        },
                        on: { click: _vm.loadmore },
                      }),
                    ]
                  ),
                ]
              : _vm._e(),
          ]
        : [
            _vm._l(12, function (i) {
              return [
                _c(
                  "div",
                  {
                    key: "tile-placeholder-" + i,
                    class: [
                      "global-material-tile",
                      _vm.constants.gridColumns[_vm.cols],
                    ],
                  },
                  [
                    _c("div", {
                      staticClass: "global-material-tile__placeholder",
                    }),
                  ]
                ),
              ]
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }